import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentContentTypeFromURL } from '../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import { CONTENT_TYPE_SURVEY } from '../../../routes';
import { CONTENT_TYPE_RESULTS } from '../../../../features/divestitureDiagnostic/routes';
import AdditionalCommentsForm from './AdditionalCommentsForm/AdditionalCommentsForm';
import AdditionalCommentsView from './AdditionalCommentsView/AdditionalCommentsView';

const AdditionalCommentsSection = ({ additionalComments, onChange }) => {
  const contentType = useSelector(getCurrentContentTypeFromURL);

  return (
    <>
      {contentType === CONTENT_TYPE_SURVEY && (
        <AdditionalCommentsForm
          onChange={onChange}
          additionalComments={additionalComments}
        />
      )}
      {contentType === CONTENT_TYPE_RESULTS && <AdditionalCommentsView />}
    </>
  );
};

export default AdditionalCommentsSection;
